import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import CampLejeuneApplicationWrapper from "@components/layouts/campLejeuneApplicationWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function CampLejeuneApplicationHome(): ReactElement {
    return (
        <CampLejeuneApplicationWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <PrivacyPolicy
                    category="Camp Lejeune Application"
                    domain="CampLejeuneApplication.com"
                />
            </div>
        </CampLejeuneApplicationWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
